import React from "react";
import HighPriority from "../../assets/images/icon/high.png";
import MediumPriority from "../../assets/images/icon/medium.png";
import LowPriority from "../../assets/images/icon/low.png";
import Completed from "../../assets/images/icon/completed.png";
import PendingIcon from "../../assets/images/icon/pending.png";
import AssignedIcon from "../../assets/images/icon/assigned.png";
import Unassigned from "../../assets/images/icon/Unassigned.png";
import Inprogess from "../../assets/images/icon/inpgress.png";
import { useQuery } from "react-query";
import "../../Styles/tms.css";
import useAxiosInstance from "../../lib/useAxiosInstance";
import { useTranslation } from "react-i18next";
const GmsStats = ({
  setStatusClick = () => {},
  statusClick,
  setPriorityClick = () => {},
  priorityClick
}) => {
  const axiosInstance = useAxiosInstance();
  const { t } = useTranslation();

  const fetchGmsSummary = async () => {
    const response = await axiosInstance.get(
      `api/grievances/getGrievanceSummary`
    );
    const gmsSummary = response?.data?.data;
    return gmsSummary;
  };
  const gmsPriorityData = useQuery(["gmsSummary"], fetchGmsSummary, {
    refetchOnWindowFocus: false
  });
  // Access the priority counts from the API response based on _id
  const priorityCounts = {};
  gmsPriorityData?.data?.forEach((priority) => {
    const priorityId = priority?._id;
    const count = priority?.count;
    priorityCounts[priorityId] = count;
  });

  // gms status summary
  const fetchGmsStatusSummary = async () => {
    const response = await axiosInstance.get(
      `api/grievances/getGrievanceStatusSummary`
    );
    const gmsStatus = response?.data?.data;
    return gmsStatus;
  };
  const gmsSummaryData = useQuery(["gmsStatus"], fetchGmsStatusSummary, {
    refetchOnWindowFocus: false
  });

  const statusCounts = {
    unassigned: 0,
    assigned: 0,
    inProgress: 0,
    pendingApproval: 0,
    complete: 0
  };

  gmsSummaryData?.data?.forEach((status) => {
    const statusId = status?._id;
    const statusCount = status?.count;
    statusCounts[statusId] = statusCount;
  });

  return (
    <>
      <div className='container-fluid w-full flex items-center justify-between gap-[1.2rem] stats-responsive mt-5 px-4'>
        {/* Priority Stats */}
        <div className='col-span-12 sm:col-span-5 tms-stats-col w-[45%] stats-items-responsive'>
          <div className="shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50 min-h-[140px]">
            {/* Animated background elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
              <div className="absolute -top-1/4 -left-1/4 w-1/2 h-1/2 bg-gradient-to-br from-blue-400/10 to-transparent rounded-full blur-2xl animate-pulse"></div>
              <div 
                className="absolute -bottom-1/4 -right-1/4 w-1/2 h-1/2 bg-gradient-to-tl from-purple-400/10 to-transparent rounded-full blur-2xl animate-pulse"
                style={{ animationDelay: "1s" }}
              ></div>
            </div>

            <h3 className="text-lg font-bold text-black mb-2 relative z-10 text-center">{t("Priority")}</h3>
            <div className='flex justify-around gap-[0.5rem] relative z-10'>
              <button
                type='button'
                className={`unified-stat-card ${priorityClick === "high" ? "active-stat-card" : ""}`}
                onClick={() =>
                  priorityClick === "high"
                    ? setPriorityClick(null)
                    : setPriorityClick("high")
                }
              >
                <img src={HighPriority} alt='high priority icon' />
                <h6>{priorityCounts["high"] || 0}</h6>
                <div className="card-label">{t("High")}</div>
              </button>

              <button
                type='button'
                className={`unified-stat-card ${priorityClick === "medium" ? "active-stat-card" : ""}`}
                onClick={() =>
                  priorityClick === "medium"
                    ? setPriorityClick(null)
                    : setPriorityClick("medium")
                }
              >
                <img src={MediumPriority} alt='medium priority icon' />
                <h6>{priorityCounts["medium"] || 0}</h6>
                <div className="card-label">{t("Medium")}</div>
              </button>

              <button
                type='button'
                className={`unified-stat-card ${priorityClick === "low" ? "active-stat-card" : ""}`}
                onClick={() =>
                  priorityClick === "low"
                    ? setPriorityClick(null)
                    : setPriorityClick("low")
                }
              >
                <img src={LowPriority} alt='low priority icon' />
                <h6>{priorityCounts["low"] || 0}</h6>
                <div className="card-label">{t("Low")}</div>
              </button>
            </div>
          </div>
        </div>

        {/* Status Stats */}
        <div className='w-[55%] stats-items-responsive'>
          <div className="shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] p-4 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50 min-h-[140px]">
            {/* Animated background elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
              <div className="absolute -top-1/4 -left-1/4 w-1/2 h-1/2 bg-gradient-to-br from-blue-400/10 to-transparent rounded-full blur-2xl animate-pulse"></div>
              <div 
                className="absolute -bottom-1/4 -right-1/4 w-1/2 h-1/2 bg-gradient-to-tl from-purple-400/10 to-transparent rounded-full blur-2xl animate-pulse"
                style={{ animationDelay: "1s" }}
              ></div>
            </div>

            <h3 className="text-lg font-bold text-black mb-2 relative z-10 text-center">{t("Status")}</h3>
            <div className='flex justify-around gap-[0.5rem] relative z-10'>
              <button
                type='button'
                className={`unified-stat-card ${statusClick === "unassigned" ? "active-stat-card" : ""}`}
                onClick={() =>
                  statusClick === "unassigned"
                    ? setStatusClick(null)
                    : setStatusClick("unassigned")
                }
              >
                <img src={Unassigned} alt='unassigned icon' />
                <h6>{statusCounts["unassigned"]}</h6>
                <div className="card-label">{t("Unassigned")}</div>
              </button>

              <button
                type='button'
                className={`unified-stat-card ${statusClick === "assigned" ? "active-stat-card" : ""}`}
                onClick={() =>
                  statusClick === "assigned"
                    ? setStatusClick(null)
                    : setStatusClick("assigned")
                }
              >
                <img src={AssignedIcon} alt='assigned icon' />
                <h6>{statusCounts["assigned"]}</h6>
                <div className="card-label">{t("Assigned")}</div>
              </button>

              <button
                type='button'
                className={`unified-stat-card ${statusClick === "inProgress" ? "active-stat-card" : ""}`}
                onClick={() =>
                  statusClick === "inProgress"
                    ? setStatusClick(null)
                    : setStatusClick("inProgress")
                }
              >
                <img src={Inprogess} alt='in progress icon' />
                <h6>{statusCounts["inProgress"]}</h6>
                <div className="card-label">{t("In Progress")}</div>
              </button>

              <button
                type='button'
                className={`unified-stat-card ${statusClick === "complete" ? "active-stat-card" : ""}`}
                onClick={() =>
                  statusClick === "complete"
                    ? setStatusClick(null)
                    : setStatusClick("complete")
                }
              >
                <img src={Completed} alt='completed icon' />
                <h6>{statusCounts["complete"]}</h6>
                <div className="card-label">{t("Completed")}</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default GmsStats;
